import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SwiperModule } from 'swiper/angular';
import { TournamentBannerModule } from '@fantaz/tournaments/ui/tournament-banner';
import { TournamentControlsModule } from '@fantaz/tournaments/ui/tournament-controls';
import { TournamentSliderComponent } from './tournament-slider.component';
import * as fromAdvertisement from '@fantaz/tournaments/data-access';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    SwiperModule,
    TournamentBannerModule,
    TournamentControlsModule,
    StoreModule.forFeature(
      fromAdvertisement.ADVERTISEMENT_FEATURE_KEY,
      fromAdvertisement.advertisementReducer,
    ),
    EffectsModule.forFeature([fromAdvertisement.AdvertisementEffects]),
  ],
  declarations: [TournamentSliderComponent],
  exports: [TournamentSliderComponent],
})
export class TournamentWidgetSliderModule {}
